/* Flick · Página de colección — orden, filtros, leer más, panel móvil */
(function () {
  function init(root) {
    if (!root || root.dataset.fkReady) return;
    root.dataset.fkReady = '1';

    /* ---- orden por disponibilidad: cargar primero los que tienen stock ---- *
       En la URL limpia el servidor devuelve el orden mezclado de Shopify. Aqui
       se pide de nuevo la seccion con el filtro nativo de disponibilidad para
       que la primera pantalla sean siempre productos comprables. Si falla, se
       queda el orden del servidor: no rompe nada.                              */
    var swapUrl = root.dataset.fkInstockUrl;
    var colMain = root.querySelector('.fk-col-main');
    if (swapUrl && colMain) {
      var done = function () { colMain.removeAttribute('data-fk-swapping'); };
      var guard = setTimeout(done, 5000); // si la red falla, se ensena igualmente
      fetch(swapUrl)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.fk-col-main');
          if (fresh) colMain.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* se mantiene lo que pinto el servidor */ })
        .then(function () { clearTimeout(guard); done(); });
    }

    /* ---- orden ---- */
    var sort = root.querySelector('[data-fk-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.assign(u.toString());
      });
    }

    /* ---- filtros: enviar al cambiar (conservando sort) ---- */
    var form = root.querySelector('[data-fk-facets]');
    if (form) {
      var submit = function () {
        // limпia campos vacíos para no ensuciar la URL
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) {
          if (i.value === '') i.disabled = true;
        });
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      };
      form.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'number') return; // el precio se aplica al salir/Enter
        submit();
      });
      Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) {
        i.addEventListener('change', submit);
        i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
      });
    }

    /* ---- leer más ---- */
    var desc = root.querySelector('[data-fk-desc]');
    var more = root.querySelector('[data-fk-more]');
    if (desc && more) {
      if (desc.scrollHeight - desc.clientHeight > 4) more.hidden = false;
      more.addEventListener('click', function () {
        var open = desc.classList.toggle('is-open');
        more.textContent = open ? 'Leer menos' : 'Leer más';
      });
    }

    /* ---- panel de filtros en móvil ---- */
    var toggle = root.querySelector('[data-fk-filtoggle]');
    var panel = root.querySelector('[data-fk-panel]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
      panel.addEventListener('click', function (e) {
        if (e.target === panel) { panel.classList.remove('is-open'); document.body.style.overflow = ''; }
      });
    }
  }

  function boot() { document.querySelectorAll('[data-fk-col]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
